import { cardTitle , grayColor} from "assets/jss/material-dashboard-pro-react.js";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import{  
  tooltip
} from "assets/jss/material-dashboard-pro-react.js";
const style = {
  ...customSelectStyle,
  cardIconTitle: {
      ...cardTitle,
      marginTop: "15px",
      marginBottom: "0px"
  },  
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px"
    }
  },
  newButton: {
    position: "absolute",
    zIndex: 3,
    right: "10px",
    top: "-35px"
  },
  modalHeader: {
    borderBottom: "none",
    paddingTop: "24px",
    paddingRight: "24px",
    paddingBottom: "0",
    paddingLeft: "24px",
    minHeight: "16.43px"
  },
  modalTitle: {
    margin: "0",
    lineHeight: "1.42857143"
  },
  modalCloseButton: {
    color: grayColor[0],
    marginTop: "-12px",
    WebkitAppearance: "none",
    padding: "0",
    cursor: "pointer",
    background: "0 0",
    border: "0",
    fontSize: "inherit",
    opacity: ".9",
    textShadow: "none",
    fontWeight: "700",
    lineHeight: "1",
    float: "right"
  },
  modalClose: {
    width: "16px",
    height: "16px"
  },
  modalMedium: {
    maxWidth: "600px",
    width: '60%'
  },
  modalLarge: {
    maxWidth: "1024px",
    width: '80%'
  },
  formControl:{
    marginBottom: "10px"
  },
  titleBold:{
    fontWeight: 'bold'
  },
  textInfo:{
    fontWeight: 'normal',
    fontSize: '14px'
  },
  boxPrint:{
    marginLeft: '15px !important'
  },
  ...buttonStyle,
  tooltip
};

export default style;